import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { MDBInput } from "mdb-react-ui-kit";
import apiService from "../../../Services/apiServices";
import { useToasts } from "react-toast-notifications";
import Search from "../../../PageComponents/Search/Search";
import globals from "../../../Services/globals";
import { confirmAlert } from "react-confirm-alert";
import helper from "../../../Services/helper";
import calculate from "../../../Services/calculate";
import Pagination from "../../../PageComponents/UI/Pagination/Pagination";
import SelectByGroup from './../../../PageComponents/UI/Inputs/SelectByGroup'
import ExcelExport from "../../../PageComponents/Excel/ExcelExport";
import Print from "../../../PageComponents/Print/Print";
import { formatData } from "../../exportFunctions/exportFunction";
import { main } from "@popperjs/core";

function ShareHolderEquity(props) {
    const [searchParams, setSearchParams] = useState({ projectId: 0, branchId: 0, includeStartDate: true, includeEndDate: true });
    const [mainData, setMainData] = useState([]);
    const [showProgress, setShowProgress] = useState(false);
    const searchObj = { CompanyBranch: 0, PurchaseType: -1, StartDate: helper().formatDate(searchParams?.startDate, 'MM-dd-yyyy'), EndDate: helper().formatDate(searchParams?.endDate, 'MM-dd-yyyy') }
    const [dataForPrint, setDataForPrint] = useState([]);
    const [dividents, setDividents] = useState([]);

    const data = (data) => {
        const modifiedData = [];
        let mData = data.filter(f => f.currentValue != 0)

        for (const item of mData) {
            modifiedData.push({
                name: item.name,
                calculateId: item.calculateId,
                currentValue: item.currentValue,
                mainItem: true
            });

            if (item.groupsInfo && item.groupsInfo.length > 0) {
                for (const groupInfo of item.groupsInfo) {
                    modifiedData.push({
                        name: groupInfo.name.trim(),
                        currentValue: groupInfo.grValue,
                        listItem: true
                    });
                }
            }
        }
        setDataForPrint(modifiedData)
    }

    const getGeneralBookWithDetails = (startDate, endDate, branchId, projectId) => {

        if (!projectId) {
            projectId = 0;
        }

        let strStartDate = helper().formatDate(startDate, 'MM-dd-yyyy');
        let strEndDate = helper().formatDate(endDate, 'MM-dd-yyyy') + " 23:59:59";

        setShowProgress(true);

        var params = `&startDate=${strStartDate}&endDate=${strEndDate}&branchId=${branchId}&projectId=${projectId}`;
        apiService().query('fnGeneralBookWithDetails', params).then((response) => {
            if (response.success) {
                let formatedData = formatData(response.data);

                let pStartDate = new Date(endDate.getFullYear() - 1, 0, 1);
                let month = endDate.getMonth();
                let day = endDate.getDate();
                let pEndDate = new Date(endDate.getFullYear() - 1, month, day);

                setSearchParams({ ...searchParams, startDate: startDate, endDate: endDate, prevStartDate: pStartDate, prevEndDate: pEndDate });

                setMainData(formatedData);
                data(formatedData);
                setShowProgress(false);

            } else {
                console.log('Error:' + response.errorMessage);
            }
        });
    };

    const getDividents = (startDate, endDate, branchId, projectId) => {
        var params = `&startDate=${startDate}&endDate=${endDate}&branchId=${branchId}&projectId=${projectId}`;
        apiService().query('dividentat', params).then((response) => {
            if (response.success) {

                setDividents(response.data[0]?.TotalDebits);
                setShowProgress(false);
            } else {
                console.log('Error:' + response.errorMessage);
            }
        });
    };

    const getDates = () => {
        let eDate = new Date();
        let sDate = new Date(eDate.getFullYear(), 0, 1, 1);
        setSearchParams({ ...searchParams, startDate: sDate, endDate: eDate });
        getGeneralBookWithDetails(sDate, eDate, 0, 0);
        getDividents(helper().formatDate('01/01/2026', 'MM-dd-yyyy'), helper().formatDate('31/12/2026', 'MM-dd-yyyy'), 0, 0);

    };

    useEffect(() => {
        getDates();
    }, []);

    return (
        <div className="container-fluid px-2 mt-3">
            <Search back="#/reportsMap/1" />
            <div className="card shadow">
                <div className="card-header border-left-primary py-2"><h6 className="m-0 font-weight-bold text-primary text-center">{helper().translate("SHAREHOLDER_EQUITY")}</h6></div>
            </div>
            <div className="card border-left-primary shadow h-100 mt-1 pt-1 pb-3 text-dark">
                <div className="container">
                    <div className="row font-weight-bold my-4" >
                        <div className="col-12  d-flex justify-content-center justify-content-md-start text-center ">
                            <h6 className="m-0 w-100 font-weight-bold text-primary text-center ">Pasqyra e ndryshimeve në ekuitet për vitin që përfundon me:</h6>
                        </div>
                    </div>

                    <div className="row mt-2 font-weight-bold inputMinWitdth" >
                        <div className=" col-12 col-md-4 d-flex justify-content-center justify-content-md-start ">
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center  ">
                            <label><p className="font-weight-bold text-dark"><u>{`Kapitali aksionar`}</u></p></label>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center   ">
                            <label><p className="font-weight-bold text-dark"><u>{`Fitimet e mbajtura`}</u></p></label>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center  ">
                            <label><p className="font-weight-bold text-dark"><u>{`Rezervat e tjera`}</u></p></label>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center   ">
                            <label><p className="font-weight-bold text-dark"><u>{`Gjithsej`}</u></p></label>
                        </div>
                    </div>

                    <div className="row mt-4 font-weight-bold inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p className="font-weight-bold text-dark"><u>Gjendja më 1 janar 2018</u> </p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right  border-dark" disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right border-dark " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right border-dark " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right border-dark " disabled ></input>
                        </div>
                    </div>

                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Fitimi / (humbja) i / e vitit</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " value="" disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " value={mainData?.find(o => o.name === "Fitimi / (humbja) i/e vitit")?.currentValue} disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right "  disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " value="" disabled ></input>
                        </div>
                    </div>

                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Diferencat nga përkthimet valutore</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " value={dividents} disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>
                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Dividendat</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>
                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Deponimet e kapitalit shtesë</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>
                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Ndarja e rezervave</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>
                    <div className="row mt-4 font-weight-bold inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p className="font-weight-bold text-dark"><u>Gjendja më 1 janar 2019</u> </p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right  border-dark" disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right border-dark " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right border-dark " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right border-dark " disabled ></input>
                        </div>
                    </div>

                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Fitimi / (humbja) i / e vitit</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>

                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Diferencat nga përkthimet valutore</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>
                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Dividendat</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>
                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Deponimet e kapitalit shtesë</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>
                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Ndarja e rezervave</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>
                    <div className="row mt-4 font-weight-bold inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p className="font-weight-bold text-dark"><u>Gjendja më 1 janar 2020</u> </p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right  border-dark" disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right border-dark " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right border-dark " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right border-dark " disabled ></input>
                        </div>
                    </div>

                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Fitimi / (humbja) i / e vitit</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>

                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Diferencat nga përkthimet valutore</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>
                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Dividendat</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>
                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Deponimet e kapitalit shtesë</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>
                    <div className="row mt-1 inputMinWitdth" >
                        <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                            <div className="text-left">
                                <p>Ndarja e rezervave</p>
                            </div>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                        <div className="col-3 col-md-2  d-flex justify-content-center justify-content-md-start ">
                            <input type="number" className="form-control form-control-sm font-weight-bold text-right " disabled ></input>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    )
}

export default ShareHolderEquity;
